import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormInput from '../../../../../commonComponents/forms/FormInput';
import translate from '../../../../../commonComponents/translate';
import { isFieldRequiredLabel } from '../../../helpers/helper';
import RequiredFieldsPerBlockProp from '../../../../../commonComponents/propTypes/requiredFieldsPerBlockProp';

function ProfileField({
  t,
  field,
  type,
  value,
  hint,
  onChange,
  inputProps,
  labelClassName,
  containerClassName,
  groupClassName,
  disabled,
  placeholder,
  block,
  requiredFieldsPerBlock,
  inputField,
  nameField,
}) {
  const label = useMemo(() => {
    if (field === 'email') {
      return `${t(`profile_${field}`)}*`;
    }
    return isFieldRequiredLabel(
      requiredFieldsPerBlock,
      block,
      inputField || field,
      t(`profile_${field}`),
    );
  }, [block, requiredFieldsPerBlock, inputField]);
  return (
    <FormInput
      id={field}
      name={nameField || field}
      value={value}
      onChange={change => onChange(field, change)}
      label={label}
      labelClassName={labelClassName}
      containerClassName={containerClassName}
      placeholder={placeholder || t(`profile_${field}Placeholder`)}
      type={type}
      hint={hint}
      groupProps={{ className: `row ${groupClassName}` }}
      inputProps={inputProps ? inputProps(field) : {}}
      disabled={disabled}
    />
  );
}

ProfileField.propTypes = {
  t: PropTypes.func.isRequired,
  field: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
    PropTypes.bool,
    PropTypes.shape({}),
  ]),
  onChange: PropTypes.func.isRequired,
  inputProps: PropTypes.func,
  type: PropTypes.string,
  hint: PropTypes.string,
  labelClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  groupClassName: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  block: PropTypes.string,
  inputField: PropTypes.string,
  nameField: PropTypes.string,
  requiredFieldsPerBlock: PropTypes.shape(RequiredFieldsPerBlockProp.propType),
};

ProfileField.defaultProps = {
  type: 'text',
  value: undefined,
  hint: undefined,
  labelClassName: 'col-lg-2 col-sm-12',
  containerClassName: 'col-lg-7 col-sm-12',
  groupClassName: '',
  disabled: false,
  inputProps: null,
  placeholder: null,
  block: '',
  inputField: null,
  nameField: null,
  requiredFieldsPerBlock: RequiredFieldsPerBlockProp.defaultProp,
};

export default React.memo(translate(ProfileField));
